// extracted by mini-css-extract-plugin
export default {"header":"styles_header__2RX6o"};